import { render, staticRenderFns } from "./RowColumnsMenu.vue?vue&type=template&id=4c48e4cc&"
import script from "./RowColumnsMenu.vue?vue&type=script&lang=js&"
export * from "./RowColumnsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports